import React,{useState} from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import { FiEdit2 } from 'react-icons/fi';
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import './EditVehicleDrawer.css'
import Offcanvas from "react-bootstrap/Offcanvas";
import { useSelector } from "react-redux";
import { updateVehicle } from "../../redux/AdminReducer";
import { useDispatch } from "react-redux";

import Swal from "sweetalert2";
const EditVehicleDrawer = (props) => {
  const dispatch=useDispatch();
  const[showDrivers,setShowDrivers]=useState(false);
  const[idDriver,setIdDriver]=useState();
  const[selectDriver,setSelectDriver]=useState("Select Driver")
  const vehicleData=useSelector((state)=>state?.AdminReducer?.allVehiclesData)

  const [vehicle,setVehicle]=useState({
        catagory:props?.data?.catagory,
        company:props?.data?.company,
        passenger:props?.data?.passenger,
        luggage:props?.data?.luggage,
        price:props?.data?.price,
        hourPrice:props?.data?.hourPrice,
        availability:false

  });

  const [imageVehicle, setImageVehicle] = useState();
  const handleChange=(e)=>{

    const{name,value}=e.target;

    console.log("e...............",e)

    setVehicle({
      ...vehicle,[name]:value
    })

  }
  const availabilityChange=(e)=>{

    

    console.log("e...............",e)

    setVehicle({
      ...vehicle,availability:!vehicle.availability
    })

  }


  const handleImage=(e)=>{
    const selected1 = e.target.files[0];

    setImageVehicle(selected1);

  }

  console.log("props?.data?._id",props?.data?._id)

  const addBtnClicked=async()=>{

    const data = new FormData();
    data.append("catagory", vehicle.catagory);
    data.append("company", vehicle.company);
    data.append("passenger", vehicle.passenger);
    data.append("luggage", vehicle.luggage);
    data.append("price", vehicle.price);
    data.append("availability", vehicle.availability);
    data.append("photo", imageVehicle);
    data.append("driverId", idDriver);
    data.append("driverEmail",selectDriver);
    data.append("hourPrice",vehicle.hourPrice);



   let id=props?.data?._id;
   const response=await dispatch(updateVehicle({id,data,vehicleData}))

console.log("response",response?.payload?.message)

    
  }

  
  const showDriversClicked=()=>{

    setShowDrivers(!showDrivers)

  }

  const driverSelectClicked=(data)=>{

    
    setSelectDriver(data?.email)
    setIdDriver(data?._id)
    setShowDrivers(!showDrivers)

  }
  return (
    <>
       {[false].map((expand) => (
        <Navbar key={expand} bg="light" expand={expand} className="mb-3">
          <Container fluid>
            {/* <Navbar.Brand href="#">Navbar Offcanvas</Navbar.Brand> */}
            {/* <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} /> */}

            <Navbar.Toggle
aria-controls={`offcanvasNavbar-expand-${expand}`}
className="btnEditVehicle"
>
<FiEdit2/>
</Navbar.Toggle>
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
              className="addVehicleDrawer"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Edit Vehicle
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div className="mainAddVehicleDrawerFields">
                <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Image :</div>
                    <input
                      placeholder="Please Enter Catagory"
                      className="inputFieldAddVeh"
                      type="file"
                      name="catagory"
                      onChange={(e)=>handleImage(e)}
                      // value={vehicle.catagory}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Catagory :</div>
                    <input
                      placeholder="Please Enter Catagory"
                      className="inputFieldAddVeh"
                      name="catagory"
                      value={vehicle.catagory}
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Company :</div>
                    <input
                      placeholder="Please Enter Company Name"
                      className="inputFieldAddVeh"
                      name="company"
                      value={vehicle.company}
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Passenger :</div>
                    <input
                      placeholder="Please Enter Passenger Capacity"
                      className="inputFieldAddVeh"
                      name="passenger"
                      value={vehicle.passenger}
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Luggage :</div>
                    <input
                      placeholder="Please Enter Luggage Capacity"
                      className="inputFieldAddVeh"
                      value={vehicle.luggage}
                      name="luggage"
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Price Per Mile:</div>
                    <input
                      placeholder="Please Enter Price"
                      className="inputFieldAddVeh"
                      name="price"
                      value={vehicle.price}
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Price Per Hour:</div>
                    <input
                      placeholder="Please Enter Price"
                      className="inputFieldAddVeh"
                      name="hourPrice"
                      value={vehicle.hourPrice}
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  {/* <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Select Driver :</div>
                    <div className="inputFieldAddVehTopSlc">
                      <div className="inputFieldAddVeh inputFieldAddVehDrivers"
                      onClick={showDriversClicked}
                      >{selectDriver}</div>
                    {showDrivers&&  <div className="selectCustomeizeDrivers">
                        {props?.driverData?.map((item)=>(
                          <div className="drinverTxtInd"
                          onClick={()=>driverSelectClicked(item)}
                          >{item?.email}</div>
                        ))}
                      </div>}
                    </div>
                  </div> */}
                  <div className="topCatagoryField topCatagoryFieldCheck">
                    <div className="catagoryTxtAddVeh">Availability :</div>
                    <label class="switch1">
                      <input type="checkbox" 
                      
                      name="availability"
                      onChange={(e)=>availabilityChange(e)}
                      
                      />
                      <span class="slider1 round1"></span>
                    </label>
                  </div>
                  <div className="topCatagoryField topCatagoryFieldCheck">
                   
                  <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-${expand}`}
           
            >
             <button className="cnclBtn">
                        Cancel
                    </button>
            </Navbar.Toggle>
               
            <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-${expand}`}
           
            >
                    
                    <button className="addBtn" onClick={addBtnClicked}>
                        Update 
                        </button>
                        </Navbar.Toggle>
                  </div>
                </div>
                
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
};

export default EditVehicleDrawer;







